import axios from 'axios';
import userStore from '../store/userStore';
import { Config } from '../config';
import getHeaders from './header';
import tableStore from '../store/tableStore';

const urlStarter = Config[Config.env].functionappurl;
const folderSpace = {};
/**
 * Retrieves all the sources from the database based on the logged in user
 */
export function gatherSources() {
    return new Promise(async (resolve, reject) => {
        console.log("Gathering source folder objects");
        let url = urlStarter + "api/trees?getFolders=true&userId=" + userStore.user.id;
        const headers = await getHeaders();

        let payload = { "id": userStore.user.id };
        axios.get(url, payload, { headers: headers }).then((results) => {
            let rf = createSourceTreeFromFlatData(results.data.message);
            resolve(folderSpace[rf]);
        }).catch((e) => {
            console.log(e);
            reject(e);
        });
    });
}
export async function getPathByName(pathName) {
    try {
        const url = `${urlStarter}api/trees?getFolderByPath=true&userId=${userStore.user.id}&companyId=${tableStore.table.companyId}`;
        const headers = await getHeaders();
        const payload = {
            getFolderByPath: pathName
        }
        const response = await axios.post(url,payload ,{ headers: headers });
        return response.data;
    } catch (error) {
        throw error;
    }
}
// Takes the flat tree and creates a nested source with children object for use in the react application sourcepicker component
function createSourceTreeFromFlatData(flatDataArray) {
    let rootFolder = '';
    // Populate the folderspace
    flatDataArray.forEach(folder => {
        if (folder.stats.my.files > 0 || folder.stats.my.folders > 0) { // Only load non-empty folders.
            folderSpace[folder.id] = {
                id: folder.id,
                parent: folder.parent,
                name: folder.path.split('\\').pop(),
                path: folder.path,
                stats: folder.stats,
                children: []
            };
            if (folder.parent === 'root') {
                rootFolder = folder.id;
            }
        }
    });

    createChild(folderSpace[rootFolder]);
    return rootFolder;
}

// Builds a set of children for the given parent, inserting them into the parent child array (nested d3 type)
function createChild(parentFolder) {
    Object.keys(folderSpace).forEach(folderID => {
        let thisFolder = folderSpace[folderID];
        if (thisFolder.parent === parentFolder.id) {
            createChild(thisFolder);
            parentFolder.children.push(thisFolder);
        }
    });
}


// WEBPACK FOOTER //
// ./src/services/sourceManager.js